import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'

import { sanitizeImageUrl } from 'utils/sanitize'
import styles from './TagPopup.pcss'

export function TagPopup(props: { anchor: HTMLElement | null }) {
  const element = props.anchor
  if (!element) {
    return null
  }
  const name = element.dataset.tagName
  const handle = element.dataset.tagHandle
  // NOTE: `data-tag-image` survives DOMPurify untouched (it has no opinion on `data-*`), so the
  // scheme is checked here, where the value becomes a live image source again.
  const imageUrl = sanitizeImageUrl(element.dataset.tagImage)

  return (
    <Popper
      open={Boolean(props.anchor)}
      anchorEl={props.anchor}
      className={styles.popup}
      placement="top"
    >
      <Paper className={styles.container}>
        <div className={styles['img-box']}>
          <img src={imageUrl} />
        </div>
        <div className={styles['tag-info']}>
          <p className={`${styles.name} text-ellipsis`} title={name}>{name}</p>
          {handle !== name && <p className={`${styles.handle} text-ellipsis`}>{handle}</p>}
        </div>
      </Paper>
    </Popper>
  )
}

export default TagPopup
